export const QUICK_CHECK_IN_SOURCE_NOTE_COLLECTION = 'progressNotes';
export const QUICK_CHECK_IN_SOURCE_NOTE_TYPE = 'capture_source_note';

const toSourceString = (value) => String(value || '');

const buildSourceNotePath = ({ childId = '', sourceNoteId = '' } = {}) => (
  childId && sourceNoteId
    ? `children/${childId}/${QUICK_CHECK_IN_SOURCE_NOTE_COLLECTION}/${sourceNoteId}`
    : ''
);

export const buildQuickCheckInSourceNotePayload = ({
  captureSource = {},
  user = null,
  serverTimestamp = null,
} = {}) => {
  const timestampFactory = typeof serverTimestamp === 'function'
    ? serverTimestamp
    : () => new Date();
  const sourceText = toSourceString(captureSource.originalText || captureSource.sourceText);

  return {
    type: QUICK_CHECK_IN_SOURCE_NOTE_TYPE,
    sourceType: captureSource.sourceType || 'quick_check_in',
    status: 'active',
    childId: captureSource.childId || null,
    childName: captureSource.childName || null,
    createdBy: user?.uid || null,
    authorId: user?.uid || null,
    authorName: user?.displayName || user?.email?.split('@')[0] || 'User',
    authorEmail: user?.email || null,
    createdAt: timestampFactory(),
    updatedAt: timestampFactory(),
    text: sourceText,
    sourceText,
    originalText: sourceText,
    rawText: sourceText,
    normalizedText: toSourceString(captureSource.normalizedText).trim(),
    selectedDate: captureSource.selectedDate || null,
    selectedLocalDate: captureSource.selectedLocalDate || null,
    selectedTime: captureSource.selectedTime || '',
    importantMoment: Boolean(captureSource.importantMoment),
    routingMode: captureSource.routingMode || '',
    routingReason: captureSource.routingReason || '',
    metadata: {
      ...(captureSource.metadata || {}),
      captureFirstSourceType: captureSource.sourceType || 'quick_check_in',
      captureFirstSourcePreserved: Boolean(sourceText.trim()),
    },
  };
};

export const saveQuickCheckInSourceNote = async ({
  captureSource = {},
  user = null,
  deps = {},
} = {}) => {
  const sourceText = toSourceString(captureSource.originalText || captureSource.sourceText);
  if (!sourceText.trim()) {
    return null;
  }

  const {
    db,
    collection,
    addDoc,
    serverTimestamp,
  } = deps;

  if (!captureSource.childId) {
    throw new Error('Child is required before saving the source note.');
  }

  if (!user?.uid) {
    throw new Error('You must be signed in before saving the source note.');
  }

  if (typeof collection !== 'function' || typeof addDoc !== 'function') {
    throw new Error('Firestore dependencies are required before saving the source note.');
  }

  const payload = buildQuickCheckInSourceNotePayload({
    captureSource,
    user,
    serverTimestamp,
  });
  const docRef = await addDoc(
    collection(db, 'children', captureSource.childId, QUICK_CHECK_IN_SOURCE_NOTE_COLLECTION),
    payload
  );
  const id = docRef?.id || '';
  const path = docRef?.path || buildSourceNotePath({
    childId: captureSource.childId,
    sourceNoteId: id,
  });

  return {
    id,
    path,
    collection: QUICK_CHECK_IN_SOURCE_NOTE_COLLECTION,
    type: QUICK_CHECK_IN_SOURCE_NOTE_TYPE,
    payload,
  };
};
